export class QuestionBase<T> {
  controlType: string;
  mask: any;
  validators: any;
  value: T;
  ChildQuestions: any;
  ConditionalClause: any;
  ConditionalDependents: any;
  MultipleResponse: string;
  MultipleResponseChild: boolean;
  Order: number;
  ParentQuestionName: string;
  QuestionName: string;
  QuestionOptions: any;
  QuestionText: string;
  QuestionTextAlt: string;
  QuestionType: any;
  ToolTip: string;
  IsOptional: boolean;
  IsHeaderQuestion: boolean;
  Units: string;
  QuestionVariations: any;
  DefaultValue: any;
  DefaultValueConditional: any;
  inputType: string;
  QuestionRestrictions: any;
  MapToOther: boolean;

  constructor(options: {
    controlType?: string,
    mask?: any,
    validators?: any,
    value?: T,
    ChildQuestions?: any,
    ConditionalClause?: any,
    ConditionalDependents?: any,
    MultipleResponse?: string,
    MultipleResponseChild?: boolean,
    Order?: number,
    ParentQuestionName?: string,
    QuestionName?: string,
    QuestionOptions?: any,
    QuestionText?: string,
    QuestionTextAlt?: string,
    QuestionType?: any,
    ToolTip?: string,
    IsOptional?: boolean,
    IsHeaderQuestion?: boolean,
    Units?: string,
    QuestionVariations?: any,
    DefaultValue?: any,
    DefaultValueConditional?: any,
    inputType?: string,
    QuestionRestrictions?: any,
    MapToOther?: boolean;
  } = {}) {
    this.controlType = options.controlType || '';
    this.mask = options.mask;
    this.validators = options.validators;
    this.value = options.value;
    this.ChildQuestions = options.ChildQuestions || [];
    this.ConditionalClause = options.ConditionalClause || null;
    this.ConditionalDependents = options.ConditionalDependents || null;
    this.MultipleResponse = options.MultipleResponse || '';
    this.MultipleResponseChild = options.MultipleResponseChild;
    this.Order = options.Order === undefined ? 1 : options.Order;
    this.ParentQuestionName = options.ParentQuestionName || '';
    this.QuestionName = options.QuestionName || '';
    this.QuestionOptions = options.QuestionOptions || [];
    this.QuestionText = options.QuestionText || '';
    this.QuestionTextAlt = options.QuestionTextAlt || '';
    this.QuestionType = options.QuestionType || [];
    this.ToolTip = options.ToolTip || '';
    this.IsOptional = options.IsOptional;
    this.IsHeaderQuestion = options.IsHeaderQuestion;
    this.Units = options.Units || '';
    this.QuestionVariations = options.QuestionVariations || '';
    this.DefaultValue = options.DefaultValue || '';
    this.DefaultValueConditional = options.DefaultValueConditional || '';
    this.inputType = options.inputType || '';
    this.QuestionRestrictions = options.QuestionRestrictions || [];
    this.MapToOther = options.MapToOther || false;
  }
}
